import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Karte = _resolveComponent("Karte")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    i18nErrorMessage: _ctx.getI18nErrorString(),
    "error-uuid": _ctx.errorUuid
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Karte, { "c-centers": _ctx.filteredCenter }, null, 8, ["c-centers"])
    ]),
    _: 1
  }, 8, ["state", "i18nErrorMessage", "error-uuid"]))
}